
import { PayrollModulePageContent } from './PayrollModulePageContent'
import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary'

export const PayrollModulePage = withDefaultErrorBoundary(PayrollModulePageContent)